import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

const STATS = [
    { value: 700, suffix: "+", label: "Продадени автомобила" },
    { value: 500, suffix: "+", label: "Доволни клиенти" },
    { value: 60, suffix: "+", label: "Налични в момента" },
    { value: 98, suffix: "%", label: "Удовлетвореност" },
];

function Counter({ to, suffix }) {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-50px" });
    const [n, setN] = useState(0);

    useEffect(() => {
        if (!inView) return;
        const duration = 1800;
        const start = performance.now();
        const tick = (t) => {
            const p = Math.min(1, (t - start) / duration);
            const eased = 1 - Math.pow(1 - p, 3);
            setN(Math.round(to * eased));
            if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
    }, [inView, to]);

    return (
        <span ref={ref} className="tabular-nums">
            {n}
            {suffix}
        </span>
    );
}

export default function Stats() {
    return (
        <section className="relative py-24 lg:py-28" data-testid="stats-section">
            <div
                className="absolute inset-0 opacity-50 pointer-events-none"
                style={{
                    background:
                        "linear-gradient(180deg, transparent, rgba(200,165,90,0.04), transparent)",
                }}
            />
            <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-8">
                    {STATS.map((s, i) => (
                        <motion.div
                            key={s.label}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.7, delay: i * 0.1 }}
                            className="text-center lg:text-left lg:border-l lg:border-line lg:pl-8"
                        >
                            <div
                                className="font-display text-5xl lg:text-6xl xl:text-7xl tracking-tightest text-gradient-gold"
                                data-testid={`stat-${i}`}
                            >
                                <Counter to={s.value} suffix={s.suffix} />
                            </div>
                            <div className="mt-3 text-xs lg:text-sm uppercase tracking-[0.25em] text-ink-muted">
                                {s.label}
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
